module.exports = __webpack_public_path__ + "static/img/22-2.4103ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/22-2.jpg
// module id = Msp5
// module chunks = 0